import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "type", "placeholder", "readonly"]

import { Ref, ref } from "vue";

//Types
import type { SizesKeysType } from "@/types/sizes.type";
import { SizesKeys } from "@/types/sizes.type";

//Component types & definitions
import {
  VariantKeys,
  VariantsType,
  variants,
  sizes,
  fontSizes,
} from "./Input";
import { Types } from "./Input";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
    type: { default: Types.text },
    modelValue: { default: "" },
    variant: { default: VariantKeys.primary },
    size: { default: SizesKeys.default },
    block: { type: Boolean, default: false },
    full: { type: Boolean, default: true },
    placeholder: {},
    required: { type: Boolean },
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    min: {},
    max: {},
    fontMono: { type: Boolean, default: false }
  },
  emits: ["FinishTyping", "update:modelValue", "input"],
  setup(__props: any, { emit: __emit }) {



const timer: Ref<ReturnType<typeof setTimeout> | null> = ref(null);

const emit = __emit;

const OnInput = (ev: Event) => {
  emit("update:modelValue", (ev?.target as HTMLInputElement).value);
  emit("input", ev);
  timer.value && clearTimeout(timer.value);
  timer.value = setTimeout(() => {
    emit("FinishTyping", ev);
  }, 400);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    value: _ctx.modelValue,
    onInput: OnInput,
    type: _ctx.type,
    placeholder: _ctx.placeholder,
    readonly: _ctx.readonly,
    class: _normalizeClass([
      _unref(variants)[_ctx.variant].classes,
      _unref(variants)[_ctx.variant].default,
      _unref(variants)[_ctx.variant].selected,
      _unref(sizes)[_ctx.size],
      _unref(fontSizes)[_ctx.size],
      _ctx.block && 'block',
      _ctx.full && 'w-full',
      _ctx.fontMono && 'font-mono',
    ])
  }, null, 42, _hoisted_1))
}
}

})